module.exports = __webpack_public_path__ + "img/pesach-give.c592cd82.jpeg";